import styled from 'styled-components'
import { typography, color, space, layout, flexbox } from 'styled-system'

import TextBase, { TextBaseProps } from 'components/ui/Typography/TextBase'

export const TextSm = styled(TextBase).attrs({ fontSizeResponsive: 'small' })``
export const TextDef = styled(TextBase).attrs({ fontSizeResponsive: 'default' })``
export const TextMd = styled(TextBase).attrs({ fontSizeResponsive: 'medium' })``
export const TextLg = styled(TextBase).attrs({ fontSizeResponsive: 'large' })``

export const TitleBase = styled(TextBase)`
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: -0.01em;
  ${typography};
  ${color};
  ${space};
  ${layout};
  ${flexbox};
`

export const TitleXs = styled(TitleBase).attrs({ fontSizeResponsive: 'small' })<TextBaseProps>``
export const TitleSm = styled(TitleBase).attrs({
  fontSizeResponsive: 'titleSmall',
})<TextBaseProps>``
export const Title2rem = styled(TitleBase).attrs({ fontSizeResponsive: 'title2rem' })``
export const TitleDef = styled(TitleBase).attrs({ fontSizeResponsive: 'title' })<TextBaseProps>``
export const Title = styled(TitleBase).attrs({ fontSizeResponsive: 'large' })<TextBaseProps>``
export const TitleMd = styled(TitleBase).attrs({ fontSizeResponsive: 'medium' })<TextBaseProps>``
export const TitleLg = styled(TitleBase).attrs({
  fontSizeResponsive: 'titleLarge',
})<TextBaseProps>``
